import { Base64 } from "js-base64";

export function serialize<T>(data: T) {
    const json = JSON.stringify(data);
    const encodedJson = encodeURIComponent(json);
    const serializedData = Base64.encode(encodedJson);
    return serializedData;
}

export function deserialize<T>(data: string) {
    const deserializedData = Base64.decode(data);
    const decodedJson = decodeURIComponent(deserializedData);
    const parsedData: T = JSON.parse(decodedJson);
    return parsedData;
}

const useDataSerializer = () => {
    return {
        serialize,
        deserialize,
    };
};

export default useDataSerializer;
